import { CloseIcon, CopyIcon, GmailLogoIcon, WhatsappLogoIcon, XLogoIcon } from '@/assets/images';
import { AppIcon } from '@/components';
import { memo } from 'react';
import { useLanguage } from '@/localization/useLanguage';
import PropTypes from 'prop-types';

export const ShareLinkModal = memo(({ viewModel }) => {
   const { t } = useLanguage();
   const { inviteLink, inviteMessage, isLoading, onCopyLink, onClose } = viewModel;
   const shareTitle = t('invite.SHARE');
   const copyLabel = t('message.ACTION_COPY');

   const encodedMessage = encodeURIComponent(inviteMessage || '');
   const whatsappShareUrl = `https://wa.me/?text=${encodedMessage}`;
   const gmailShareUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(
      shareTitle,
   )}&body=${encodedMessage}`;
   const xShareUrl = `https://twitter.com/intent/tweet?text=${encodedMessage}`;

   const openShareWindow = url => {
      window.open(url, '_blank', 'noopener,noreferrer');
   };

   return (
      <div className="invite-share-modal invite-screen--share ct-flex ct-fcol">
         <div className="invite-share-header ct-flex ct-aiCenter ct-jcBetween">
            <h3 className="invite-share-title">{shareTitle}</h3>
            <button
               type="button"
               className="invite-share-close ct-cursor ct-flexCenter"
               onClick={onClose}
               aria-label={t('common.CLOSE')}
            >
               <AppIcon size="sm-2" icon={<CloseIcon />} />
            </button>
         </div>

         <div className="invite-share-actions ct-flex ct-aiStart ct-jcBetween">
            <button
               type="button"
               className="invite-share-action ct-flex ct-fcol ct-aiCenter ct-cursor"
               onClick={onCopyLink}
               disabled={isLoading}
            >
               <span className="invite-share-action-icon invite-share-action-icon--copy ct-flex ct-aiCenter ct-jcCenter">
                  <AppIcon size="sm-2" icon={<CopyIcon />} />
               </span>
               <span className="invite-share-action-label">{copyLabel}</span>
            </button>

            <button
               type="button"
               className="invite-share-action ct-flex ct-fcol ct-aiCenter ct-cursor"
               aria-label="WhatsApp"
               onClick={() => openShareWindow(whatsappShareUrl)}
               disabled={!inviteLink || isLoading}
            >
               <span className="invite-share-action-icon invite-share-action-icon--whatsapp ct-flex ct-aiCenter ct-jcCenter">
                  <WhatsappLogoIcon className="invite-share-brand-icon" aria-hidden="true" />
               </span>
               <span className="invite-share-action-label">WhatsApp</span>
            </button>

            <button
               type="button"
               className="invite-share-action ct-flex ct-fcol ct-aiCenter ct-cursor"
               aria-label="Gmail"
               onClick={() => openShareWindow(gmailShareUrl)}
               disabled={!inviteLink || isLoading}
            >
               <span className="invite-share-action-icon invite-share-action-icon--gmail ct-flex ct-aiCenter ct-jcCenter">
                  <GmailLogoIcon className="invite-share-brand-icon" aria-hidden="true" />
               </span>
               <span className="invite-share-action-label">Gmail</span>
            </button>

            <button
               type="button"
               className="invite-share-action ct-flex ct-fcol ct-aiCenter ct-cursor"
               aria-label="X"
               onClick={() => openShareWindow(xShareUrl)}
               disabled={!inviteLink || isLoading}
            >
               <span className="invite-share-action-icon invite-share-action-icon--x ct-flex ct-aiCenter ct-jcCenter">
                  <XLogoIcon className="invite-share-brand-icon" aria-hidden="true" />
               </span>
               <span className="invite-share-action-label">X</span>
            </button>
         </div>
      </div>
   );
});

ShareLinkModal.propTypes = {
   viewModel: PropTypes.shape({
      inviteLink: PropTypes.string,
      inviteMessage: PropTypes.string,
      isLoading: PropTypes.bool,
      onCopyLink: PropTypes.func.isRequired,
      onClose: PropTypes.func.isRequired,
   }).isRequired,
};
